import { configureStore } from '@reduxjs/toolkit'
import counterReducer from './modules/counter'
import configReducer from './modules/config'
import authSliceReducer from './modules/authSlice'

const store = configureStore({
  reducer: {
    counter: counterReducer,
    config: configReducer,
    authSlice: authSliceReducer
  }
})

type GetStateFnType = typeof store.getState
export type IRootState = ReturnType<GetStateFnType>
export type DispatchType = typeof store.dispatch

export default store
